import React from "react";
export const TelegramFilled = ({
  size = 20
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 2C37.703 2 48 12.297 48 25C48 37.703 37.703 48 25 48C12.297 48 2 37.703 2 25C2 12.297 12.297 2 25 2ZM32.934 34.375C33.357 33.077 35.339 20.141 35.584 17.592C35.658 16.82 35.414 16.307 34.936 16.078C34.358 15.8 33.502 15.939 32.509 16.297C31.147 16.788 13.735 24.181 12.729 24.609C11.775 25.014 10.873 25.456 10.873 26.096C10.873 26.546 11.14 26.799 11.876 27.062C12.642 27.335 14.571 27.92 15.71 28.234C16.807 28.537 18.056 28.274 18.756 27.839C19.498 27.378 28.061 21.648 28.676 21.146C29.29 20.644 29.78 21.287 29.278 21.79C28.776 22.292 22.898 27.997 22.123 28.787C21.182 29.746 21.85 30.74 22.481 31.138C23.202 31.592 28.387 35.07 29.168 35.628C29.949 36.186 30.741 36.439 31.466 36.439C32.191 36.439 32.573 35.484 32.934 34.375Z",
    fill: "currentColor"
  }));
};
//# sourceMappingURL=TelegramFilled.js.map